module.exports = __webpack_public_path__ + "b4ab737002410620daa3465796acaa98.fbx";